var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import cx from "classnames";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { IFRAMED } from "metabase/lib/dom";
import { color } from "metabase/lib/colors";
import { space } from "metabase/styled-components/theme";
import { FullWidthContainer } from "metabase/styled-components/layout/FullWidthContainer";
import LoadingAndErrorWrapper from "metabase/components/LoadingAndErrorWrapper";
import { APP_BAR_HEIGHT, NAV_SIDEBAR_WIDTH } from "metabase/nav/constants";
export const DashboardLoadingAndErrorWrapper = styled((_a) => {
  var _b = _a, { isFullscreen, isNightMode, className } = _b, props = __objRest(_b, ["isFullscreen", "isNightMode", "className"]);
  return /* @__PURE__ */ _jsx(LoadingAndErrorWrapper, __spreadValues({
    className: cx(className, "Dashboard", {
      "Dashboard--fullscreen": isFullscreen,
      "Dashboard--night": isNightMode
    })
  }, props));
})`
  flex: 1 0 auto;

  // prevents header from scrolling so we can have a fixed sidebar
  ${({ isFullHeight }) => isFullHeight && css`
      height: 100%;
    `}
`;
export const DashboardStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-x: hidden;
  width: 100%;
`;
export const DashboardBody = styled.div`
  display: flex;
  flex: 1 0 auto;
  min-width: 0;
  min-height: 0;

  ${({ isEditingOrSharing }) => isEditingOrSharing && css`
      flex-basis: 0;
    `}
`;
export const HeaderContainer = styled.header`
  background-color: white;
  border-bottom: 1px solid ${color("border")};
  position: relative;
  z-index: 2;

  ${({ isFullscreen }) => isFullscreen && css`
      background-color: transparent;
      border: none;
    `}

  ${({ isNightMode }) => isNightMode && css`
      color: ${color("text-white")};
    `}
`;
export const ParametersAndCardsContainer = styled.div`
  flex: auto;
  overflow-x: hidden;
`;
export const ParametersWidgetContainer = styled(FullWidthContainer)`
  align-items: flex-start;
  background-color: ${color("bg-light")};
  border-bottom: 1px solid ${color("bg-light")};
  display: flex;
  flex-direction: column;
  padding-top: ${space(2)};
  padding-bottom: ${space(1)};
  z-index: 4;

  ${({ isEditing }) => isEditing && css`
      border-top: 1px solid ${color("border")};
    `}

  ${({ isSticky }) => isSticky && css`
      border-bottom: 1px solid ${color("border")};
      position: fixed;
      top: 0;
      left: 0;
    `}

  ${({ isSticky, isNavbarOpen }) => isSticky && isNavbarOpen && !IFRAMED && css`
      width: calc(100% - ${NAV_SIDEBAR_WIDTH});
      left: ${NAV_SIDEBAR_WIDTH};
      top: ${APP_BAR_HEIGHT};
    `}
`;
export const CardsContainer = styled(FullWidthContainer)`
  ${({ addMarginTop }) => addMarginTop && css`
      margin-top: ${space(2)};
    `}
`;
